export { default } from "./uploadArea";
